import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableHead, TableRow, TableCell } from '@mui/material';

/**
 * DocumentTableHeader - Table header row with column names
 *
 * Pure presentational component for the table header.
 * Displays column names for: Title, Visibility, Owner, Shared Groups, Shared Users, Source, Actions
 */
export const DocumentTableHeader: React.FC = () => {
  const { t } = useTranslation();

  return (
    <TableHead>
      <TableRow>
        <TableCell>{t('documents.table.title')}</TableCell>
        <TableCell>{t('documents.table.visibility')}</TableCell>
        <TableCell>{t('documents.table.owner')}</TableCell>
        <TableCell>{t('documents.table.sharedGroups')}</TableCell>
        <TableCell>{t('documents.table.sharedUsers')}</TableCell>
        <TableCell>{t('documents.table.sourceType')}</TableCell>
        <TableCell align="right">{t('documents.table.actions')}</TableCell>
      </TableRow>
    </TableHead>
  );
};

DocumentTableHeader.displayName = 'DocumentTableHeader';
